import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import 'next/stylesheets/components/project/creation/preparation.scss';

Component('tr-project-creation-preparation', {
  properties: {
    preparationUrl: String,
  },

  ready() {
    if (!this.preparationUrl) return;
    this.startCheckPreparation();
  },

  startCheckPreparation() {
    this.stopCheckPreparation();
    this.checkPreparationTimer = setTimeout(() => {
      this.checkPreparation();
    }, 3000);
  },

  stopCheckPreparation() {
    if (this.checkPreparationTimer) {
      clearTimeout(this.checkPreparationTimer);
      this.checkPreparationTimer = null;
    }
  },

  checkPreparation() {
    $.getJSON(this.preparationUrl).then(({ redirectUrl, permissions, kanban }) => {
      if (redirectUrl) {
        if (permissions) window.tower.permissions = permissions;
        window.tower.stack.load(redirectUrl, {
          root: true,
          fluid: kanban,
        });
      } else {
        this.startCheckPreparation();
      }
    });
  },

  disconnected() {
    this.stopCheckPreparation();
  },
});
